<template>
  <div class="wrapper">
    <div class="toptop">
      <!--<van-row class="top">
        <van-row type="flex" align="center">
          <span class="ev">物流服务</span>
          <van-rate v-model="logistics_server" :size="25" :count="5"  color="#E52B25" void-color="#bbbbbb" />
        </van-row>
        <van-row type="flex" align="center">
          <span class="ev">卖家服务</span>
          <van-rate v-model="seller_server" :size="25" :count="5"  color="#E52B25" void-color="#bbbbbb" />
        </van-row>
      </van-row>-->
      <van-row class="goodbox" v-for="(item,index) in list" :key="index">
        <van-row class="info" type="flex" align="center">
          <img :src="item.commodity_first_pic" alt>
          <van-col class="name sigle-h">
            <!-- <span>{{item.commodity_name}}</span> -->
            <van-row type="flex" align="center">
              <van-rate v-model="item.evaluate" :count="5" color="#E52B25" void-color="#bbbbbb" />
            </van-row>
          </van-col>
        </van-row>
        <van-row class="input">
          <van-field type="textarea" placeholder="宝贝满足你的期待吗？留下您宝贵的评价，分享给想买的他们吧！" rows="5" autosize
            v-model="item.content" />
        </van-row>
        <van-row class="upload" @click.native="choose(index)">
          <van-row type="flex" style="flex-wrap: wrap">
            <van-col class="img" v-for="(item1,index1) in item.imglist" :key="index1">
              <img :src="item1 + `${imgCrop}resize,w_200`" alt>
              <img src="./../../assets/images/evaluate/close.png" alt class="colse" @click="delimg(index1)">
            </van-col>
            <!--上传图片的框子-->
            <van-uploader :after-read="upload" accept="image/*"
              v-if="!item.imglist||(item.imglist && item.imglist.length != 9)" :before-read="beforeRead">
              <van-row class="uploadbox">
                <img src="./../../assets/images/evaluate/camera.png" alt>
                <span v-if="item.imglist&&item.imglist.length!=0">{{item.imglist.length}}/9</span>
                <span v-else>添加图片</span>
              </van-row>
            </van-uploader>
          </van-row>
        </van-row>
      </van-row>
    </div>

    <van-row class="bottom">
      <van-button type="danger" class="btn" @click.native="btn" :disabled="disabled">提交评价</van-button>
    </van-row>
  </div>
</template>

<script>
  import { dataURLtoFile, photoCompress, checkempty } from "../../assets/js/tool";
  import axios from "axios";
  import OSS from "ali-oss";
  import ObsClient from "esdk-obs-browserjs/src/obs";
  import weChatShareApi from "../../assets/js/weChatShare";
  export default {
    components: {},
    props: {},
    mixins: [weChatShareApi],
    data() {
      return {
        logistics_server: 5,
        seller_server: 5,
        list: "",
        imglistindex: 0, //用于记录上传图片点的是第几个商品,用于上传完成图片之后展示图片
        disabled: false,
        order_nbr: "" //订单编号
      };
    },
    watch: {},
    methods: {
      choose(index) {
        this.imglistindex = index;
      },
      beforeRead(file) {
        if (file.type == 'image/jpeg' || file.type == 'image/jpg' || file.type == 'image/png' || file.type == 'image/gif') {
          console.log(file.type)
          return true;
        } else {
          this.$toast({ message: `请上传图片格式为jpg，jpeg，png，gif格式！` });
          return false;
        }
      },
      upload(file) {
        const that = this;
        let toast = this.$toast.loading({
          duration: 0
        });
        let quality = Number((1048576 / file.file.size).toFixed(1)); //压缩到1m以内  算出压缩比例
        photoCompress(file.file, callback, quality); //将图片进行压缩
        function callback(res) {
          let newFile = dataURLtoFile(res, file.file.name);
          let url = that.uploadPath("images/comment", newFile);
          if (that.uplaodServer == 'aliyun') {
            that.$post("/api/customer/getOSSToken", {
              userNbr: that.userInfo.nbr,
              token: "123456"
            })
              .then(data => {
                let OSSToken = data.object.resp;
                if (OSSToken.resp_code == 0 && OSSToken.resp_result == 0) {
                  let client = new OSS({
                    //            region: '购买的区域',
                    endpoint: OSSToken.endpoint,
                    bucket: OSSToken.bucketName,
                    accessKeyId: OSSToken.accessKeyId,
                    accessKeySecret: OSSToken.accessKeySecret,
                    stsToken: OSSToken.securityToken,
                  });
                  client.options.endpoint.protocol = "https:";
                  client
                    .put(url, newFile)
                    .then(data => {
                      let imgUrl =
                        that.cdnImgPath + '/' +
                        data.name;
                      if (!that.list[that.imglistindex].imglist) {
                        that.list[that.imglistindex].imglist = [imgUrl];
                      } else {
                        that.list[that.imglistindex].imglist.push(imgUrl);
                      }
                      that.$forceUpdate();
                      toast.clear();
                    })
                    .catch(error => {
                      toast.clear();
                      that.$toast({
                        message: "上传失败",
                        duration: 2000
                      });
                    });
                } else {
                  that.$toast({
                    message: OSSToken.resp_msg,
                    duration: 2000
                  });
                }
              })
              .catch(err => {
                that.$toast({
                  message: err.message,
                  duration: 2000
                });
              });
          } else {
            that.$post("/api/customer/getObsToken", {
              userNbr: that.userInfo.nbr,
              token: "123456",
            })
              .then((data) => {
                let OBSToken = data.object.resp;
                if (OBSToken.resp_code == 0 && OBSToken.resp_result == 0) {
                  let client = new ObsClient({
                    access_key_id: OBSToken.accessKeyId,
                    secret_access_key: OBSToken.accessKeySecret,
                    server: OBSToken.endpoint,
                    security_token: OBSToken.securityToken,
                    timeout: 3000, // 设置超时时间
                  });
                  client.putObject(
                    {
                      Bucket: OBSToken.bucketName, // 桶名
                      Key: url, // 文件名
                      SourceFile: newFile,
                    },
                    function (err, result) {
                      if (err) {
                        toast.clear();
                        that.$toast({
                          message: "上传失败",
                          duration: 2000,
                        });
                      } else {
                        if (result.CommonMsg.Status < 300) {
                          let imgUrl = that.cdnImgPath + "/" + url;
                          if (!that.list[that.imglistindex].imglist) {
                            that.list[that.imglistindex].imglist = [imgUrl];
                          } else {
                            that.list[that.imglistindex].imglist.push(imgUrl);
                          }
                          that.$forceUpdate();
                          toast.clear();
                        }
                      }
                    }
                  );
                } else {
                  that.$toast({
                    message: OBSToken.resp_msg,
                    duration: 2000,
                  });
                }
              })
              .catch((err) => {
                that.$toast({
                  message: err.message,
                  duration: 2000,
                });
              });
          }
        }
      },
      uploadPath(path, file) {
        let name = file.name.replace("wxfile://", "");
        let random = Math.round(Math.random() * 100000);
        // ${name.split(".")[0]}
        return `${path}/${this.userInfo.nbr}-${new Date().getTime()}.${file.type.split("/")[1]
          }`;
      },
      delimg(index) {
        this.list[this.imglistindex].imglist.splice(index, 1);
        this.$forceUpdate();
      },
      btn() {
        let that = this;
        let list = this.list;
        for (let i = 0; i < list.length; i++) {
          if (!list[i].evaluate) {
            return that.$toast({ message: `请填写商品评价内容！` });
            break;
          }
          // if (!list[i].content) {
          //   return that.$toast({ message: `请输入第${i + 1}件商品的评价` });
          //   break;
          // }
        }

        let obj = {
          sub_flow: "flow_10017",
          user_nbr: this.userInfo.nbr,
          comment_list: {
            comment: []
          }
        };

        list.map(item => {
          let iObj = {
            order_nbr: that.order_nbr,
            commodity_nbr: item.commodity_nbr,
            commodity_record_nbr: item.commodity_record_nbr,
            comment_score: item.evaluate,
            comment_content: item.content,
            comment_image: ""
          };
          if (!item.imglist) {
            item.imglist = [];
          }
          item.imglist.map((imgItem, index) => {
            if (item.imglist.length == 1 || index == item.imglist.length - 1) {
              iObj.comment_image += imgItem;
            } else {
              iObj.comment_image += imgItem + ',';
            }
          });
          obj.comment_list.comment.push(iObj);
        });
        const toast = this.$toast({
          type: "loading",
          message: "正在提交..."
        });
        this.$commonPost({
          jydm: "flow_10000",
          flow_10000: obj
        })
          .then(resp => {
            that.$toast({
              message: "已完成评价",
              duration: 2000
            });
            that.$router.push({ path: "/myorder", query: { index: 4, supNbr: this.userInfo.nbr } });
            that.$store.commit("SENDpayment", 1);
          })
          .catch(err => {
            that.$toast({
              message: err.message,
              duration: 2000
            });
          });

        /*let commentInfo = [];
        const that = this;
        let arr = [
          { val: that.logistics_server, toast: "请评价物流服务" },
          { val: that.seller_server, toast: "请评价卖家服务" }
        ];
        for (var k in that.list) {
          let obj = {
            val: that.list[k].evaluate ? that.list[k].evaluate : "",
            toast: "请评价" + that.list[k].goods_name + "的星级"
          };
          arr.push(obj);
          obj = {
            val: that.list[k].content,
            toast: that.list[k].goods_name + "的评价内容不能为空"
          };
          arr.push(obj);
        }
        console.log(arr);
        let result = true;
        for (var index = 0; index < arr.length; index++) {
          if (!checkempty(arr[index].val, arr[index].toast)) {
            result = false;
            break;
          }
        }
        if (!result) {
          that.disabled = false;
          return;
        }
        that.list.forEach(function(val, index) {
          let obj = {
            user_id: that.userInfo.id,
            goods_id: val.goods_id,
            sun_order_id: val.id,
            logistics_server: that.logistics_server,
            seller_server: that.seller_server,
            goods_intro: val.evaluate,
            content: val.content,
            images: val.imglist.join(",")
          };
          commentInfo.push(obj);
        });
        const toast = this.$toast({
          type: "loading",
          message: "正在提交...",
          mask: true
        });
        that.$post("/api/orders/comment_goods", { commentInfo: commentInfo })
          .then(res => {
            toast.clear();
            that.$toast(res.msg);
            if (res.code == 1) {
              setTimeout(function() {
                that.disabled = false;
                that.$store.commit("SENDpayment", 1);
                that.$router.go(-1);
              }, 1000);
            } else {
              that.disabled = false;
            }
          });*/
      },
      initPage() {
        this.order_nbr = this.$route.query.nbr;
        let option = {
          title: '有米@' + this.userInfo.name + '的店铺',
          desc: "欢迎光临我的店铺",
          link: location.origin + "/?supNbr=" + this.userInfo.nbr,
          images: this.userInfo.imgUrl,
        };
        this.weChatShare(option);
        this.$commonPost({
          jydm: "flow_30011",
          flow_30011: {
            order_nbr: this.order_nbr,
            wechat_version: 1
          }
        })
          .then(resp => {
            let arr = [];
            if (resp.commodity.length > 0) {
              arr = resp.commodity;
            } else {
              arr.push(resp.commodity);
            }
            this.list = arr;
          })
          .catch(err => {
            this.$toast({
              message: err.message,
              duration: 2000
            });
          });
      }
    },
    created() {
      document.title = "评价订单";
      this.initPage()
    },
    mounted() {

    }
  };
</script>
<style scoped lang='stylus'>
  .top>>>.van-icon {
    font-size: 0.5rem !important;
  }

  .goodbox>>>.van-icon {
    font-size: 0.5rem !important;
  }
</style>
<style scoped lang='less'>
  .wrapper {
    width: 100%;
    min-height: 100vh;
    background: #f5f5f5;
  }

  .toptop {
    padding-bottom: 2.06rem;

    .top {
      background: #ffffff;
      font-size: 0.28rem;
      color: #333333;
      height: 2.04rem;
      display: flex;
      padding: 0.44rem 0.28rem;
      padding-top: 0;
      box-sizing: border-box;
      justify-content: space-between;
      flex-direction: column;

      .ev {
        display: inline-block;
        margin-right: 0.5rem;
      }
    }

    .top:after {
      display: none;
    }

    .goodbox {
      padding: 0.15rem 0 .24rem;
      box-sizing: border-box;
      background: #fff;
      margin-top: 0.24rem;

      .info {
        padding: 0 .24rem 0.15rem;
        box-sizing: border-box;
        border-bottom: 1px solid #ebebeb;

        .van-row:after {
          display: none;
        }

        img {
          width: .78rem;
          height: .78rem;
          margin-right: 0.32rem;
        }

        .name {
          color: #333333;
          display: flex;
          align-items: center;
        }
      }

      .input {
        .van-cell {
          padding: 0.17rem .24rem 0;
        }
      }

      .upload {
        padding: .22rem 0.24rem 0;
        background: #ffffff;

        .title {
          font-size: 0.28rem;
          color: #333333;
        }

        .img {
          margin-top: 0.1rem;
          margin-right: 0.12rem;
          width: 1.68rem;
          height: 1.68rem;
          position: relative;

          img {
            width: 100%;
            height: 100%;
            border-radius: .06rem;
          }

          .colse {
            width: 0.4rem;
            height: 0.4rem;
            position: absolute;
            top: -0.14rem;
            right: -0.06rem;
          }
        }

        .img:nth-child(4n) {
          margin-right: 0;
        }

        .uploadbox {
          margin-top: 0.1rem;
          width: 1.68rem;
          height: 1.68rem;
          background: #fff;
          border-radius: 0.06rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-size: 0.24rem;
          color: #999;
          box-sizing: border-box;
          border: 1px dashed #979797;

          img {
            width: 0.38rem;
            height: 0.35rem;
            margin-bottom: 0.16rem;
          }
        }
      }
    }

    .goodbox:first-child {
      margin-top: 0;
    }
  }

  .bottom {
    width: 100%;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    background: #ffffff;

    .btn {
      width: 100%;
      height: 0.98rem;
      font-size: 0.3rem;
    }

    .van-button--danger {
      color: #fff;
      background: #E52B25;
      border: 1px solid #E52B25;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/information/evaluate.vue